import { render } from "./OnboardingStep3.vue?vue&type=template&id=12dd6c1b"
import script from "./OnboardingStep3.vue?vue&type=script&lang=js"
export * from "./OnboardingStep3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__